// libs
import React from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// components
import Tooltip from '@/components/Tooltip/Tooltip';
// styles
import styles from './EllipsizeContent.module.scss';
import { format } from '@/helpers/utils';
const SUFFIX = ' +{0} more';
const EllipsizeContent = ({ options, renderFunction, ellipsizeCount = 3, suffixText = SUFFIX, }) => {
    const renderOption = typeof renderFunction === 'function'
        ? renderFunction
        : (option, index) => {
            const color = index > ellipsizeCount - 1
                ? DlsColorTokens.text_inverse_Highest_Emphasis
                : DlsColorTokens.text_Med_Emphasis;
            const appendComma = index !== options.length - 1 &&
                index !== ellipsizeCount - 1;
            return (React.createElement(Text, { key: index, variant: DlsFontVariants.body_B2_Med, color: color },
                option,
                appendComma && ', '));
        };
    const renderTooltipContent = () => {
        return options
            .slice(ellipsizeCount)
            .map((option, index) => renderOption(option, index + ellipsizeCount));
    };
    const renderShowMore = () => {
        const tooltipContent = renderTooltipContent();
        return (React.createElement(Tooltip, { content: tooltipContent, contentClassName: styles.container },
            React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.primary }, format(suffixText, options.length - ellipsizeCount))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.container },
            options.slice(0, ellipsizeCount).map(renderOption),
            options.length > ellipsizeCount && renderShowMore())));
};
export default EllipsizeContent;
